module.exports = __webpack_public_path__ + "static/media/7.777e5cc7.jpg";